import type { Translations } from '../../../types'

const shopPriceStockMessages: Translations = {
  "shop.priceStock.title": "Prezzo e stock",
  "shop.priceStock.fields.price": "Prezzo (IVA inclusa) *",
  "shop.priceStock.fields.pricePlaceholder": "0.00",
  "shop.priceStock.fields.quantity": "Quantità *",
  "shop.priceStock.fields.quantityPlaceholder": "0",
  "shop.priceStock.grossPreview": "Prezzo inserito IVA inclusa",
  "shop.priceStock.netPreview": "Imponibile stimato",
  "shop.priceStock.vatPreview": "IVA stimata",
}

export default shopPriceStockMessages
